<div class="question-wizard-container">
    <div class="content p-5">
        <ng-container *ngIf="!currentPage">
            <div
                class="pb-5"
                [innerHTML]="questionsSlide.description | bypassSecurity: 'html'"
            ></div>
            <app-button class="justify-content-center d-flex" (click)="goToPage(1)"
                >Begin Questions</app-button
            >
        </ng-container>
        <ng-container *ngIf="currentPage">
            <h4 class="mb-4">Q{{ currentPage }}</h4>
            <div class="mb-4">{{ currentQuestion.text }}</div>
            <textarea
                class="p-4 mb-4"
                placeholder="Type your answer here"
                [disabled]="currentQuestion.hasAnswer()"
                [(ngModel)]="currentQuestion.userInput"
                (keyup)="count()"
                *ngIf="!currentQuestion.options"
            ></textarea>
            <div class="counter mb-4" *ngIf="!currentQuestion.options && totalChars">
                {{ leftChars }} / {{ totalChars }} Characters
            </div>
            <div class="options p-4 mb-4" *ngIf="currentQuestion.options">
                <ng-container *ngFor="let option of currentQuestion.options">
                    <label class="me-7" [ngClass]="{ stack: currentQuestion.options.length > 2 }">
                        <input
                            class="me-2"
                            type="radio"
                            [value]="option.pk"
                            [(ngModel)]="currentQuestion.userInput"
                            [disabled]="currentQuestion.hasAnswer()"
                            [checked]="isChecked(option.pk)"
                        />
                        <span class="label-text">{{ option.text }}</span>
                    </label>
                </ng-container>
            </div>
            <div class="status mb-4" *ngIf="currentQuestion.hasAnswer()">
                <span class="not-correct" *ngIf="currentQuestion.getAnswerValidation() === false"
                    >That is not correct!</span
                >
                <span class="correct" *ngIf="currentQuestion.getAnswerValidation()"
                    >That is correct!</span
                >
            </div>
            <app-button
                *ngIf="!currentQuestion.hasAnswer()"
                (click)="submitAnswer()"
                [disable]="isCharLimitExceeded() || !currentQuestion.hasInput()"
                >Submit Answer</app-button
            >
            <app-button *ngIf="currentQuestion.hasAnswer() && !isLast()" (click)="onNext()"
                >Next Question</app-button
            >
        </ng-container>
    </div>
    <div class="pagination-wrapper">
        <span class="intro" [ngClass]="{ active: !currentPage }" (click)="goToPage(0)">INTRO</span>

        <app-pagination
            appMarkPage
            [questions]="questionsSlide.questions"
            (goPage)="goToPage($event)"
            (goNext)="onNext()"
            (goPrev)="onPrev()"
            [loading]="loading"
            [pagesToShow]="7"
            [page]="currentPage"
            [perPage]="1"
            [count]="questionsCount"
            [simplePagination]="true"
        ></app-pagination>
    </div>
</div>
